import { nanoid } from 'nanoid'
import { Accordion, Tag, Row, Col } from '@mch-group/uikit-components'
import { FC } from 'react'
import { Text } from '@components'
import ApplicationForm from './ApplicationForm'
import { getLabelStatus } from './utils'

interface IApplicationAccordion {
  shows: any
  statuses: any
  props: any
  press: any
  profile: any
  labels: any
}

const ApplicationAccordion: FC<IApplicationAccordion> = ({ shows, statuses, props, press, profile, labels }) =>
  shows?.length > 0 ? (
    <Accordion section theme='light' cssInternalPrefix='accordion' defaultActiveKey='0'>
      {shows.map((i, index) => {
        if (!i.mediaAccreditation) {
          i.mediaAccreditation = { status: 102900000 }
        }
        return (
          <Accordion.Item eventKey={index?.toString()} key={nanoid()}>
            <Accordion.Header section>
              {i?.event?.name}
              <Tag
                type={getLabelStatus(i.mediaAccreditation.status).type}
                theme='light'
                label={props[getLabelStatus(i.mediaAccreditation.status).label]}
                variant='status'
                size='s'
              />
            </Accordion.Header>
            <Accordion.Body className='pt-1 pt-sm-2 pt-md-2 pt-xl-4 mt-0 pb-0 mb-0'>
              <ApplicationForm
                event={i?.event}
                mediaAccreditation={i?.mediaAccreditation}
                statuses={statuses}
                props={props}
                press={press}
                profile={profile}
                labels={labels}
              />
            </Accordion.Body>
          </Accordion.Item>
        )
      })}
    </Accordion>
  ) : (
    <Row>
      <Col xs={12} md={6}>
        <Text isHtml forwardedAs='p' className={`${props.mID}__no-open-application text-medium mt-7 mt-md-10`}>
          {props.mpaa_no_app_open}
        </Text>
      </Col>
    </Row>
  )

export default ApplicationAccordion
